module.exports = __webpack_public_path__ + "media/images/lb/251-924b20c2881b25886c0c74aabcc95433.svg";